
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-4">
        <h2><span class="fontIcon"><font-awesome-icon :icon="['fal', 'file-alt']"></font-awesome-icon></span> {{ msg }} {{customerName}}</h2>
      </div>
    </div>
     <div class="content-section implementation dataview-demo">
        <DataView :value="orders" :layout="layout" paginatorPosition="both" :paginator="true" :rows="20" :sortOrder="sortOrder" :sortField="sortField">
            <template #header>
                <div class="p-grid p-nogutter">
                    <div class="p-col-3" style="text-align: left">
                        <Dropdown v-model="sortKey" :options="sortOptions" optionLabel="label" placeholder="Sortera efter" @change="onSortChange($event)"/>
                    </div>
                    <div class="p-col-9 text-right">
                      <div class="filterOrdersWrapper">
                        <ul>
                          <li :class="{active: activeBtn === 'all' }"><button @click="filterOrders('all')" class="btn btn-primary">Alla</button></li>
                          <li :class="{active: activeBtn === 'godkänd' }"><button @click="filterOrders('uppdaterad')" class="btn btn-primary">Uppdaterade</button></li>
                          <li :class="{active: activeBtn === 'aktiv' }"><button @click="filterOrders('aktiv')" class="btn btn-primary">Aktiva</button></li>
                          <li :class="{active: activeBtn === 'avslutad' }"><button @click="filterOrders('avslutad')" class="btn btn-primary">Avslutade</button></li>
                          <li :class="{active: activeBtn === 'fakturerad' }"><button @click="filterOrders('fakturerad')" class="btn btn-primary">Fakturerade</button></li>
                        </ul>
                      </div>
                    </div>
                </div>
                <div class="row orderListHeader" style="margin-top: 15px">
                  <div class="col-md-1">Status</div>
                  <div class="col-md-2">Ordernummer</div>
                  <div class="col-md-2">Orderdatum</div>
                  <div class="col-md-2" v-for="orderSchemaField in activeColumns" :key="orderSchemaField.label">
                    {{orderSchemaField.label}}
                  </div>
                  <div class="col-md-1">Totalt</div>
                  <div class="col-md-1">Lastbil</div>
                  </div>
            </template>
            <template #list="slotProps">
              <div class="row orderListItem" :class="slotProps.data.state" v-on:click="orderDetails(slotProps.data, ordersSchema)">
                <div class="col-md-1 stateColumn">{{slotProps.data.state}}</div>
                <div class="col-md-2">{{ slotProps.data.id }}</div>
                <div class="col-md-2">{{ slotProps.data.data.startDate }} - {{ slotProps.data.data.endDate }}</div>
                <div class="col-md-2">{{ getCustomer(slotProps.data.data.kund) }}</div>
                <div class="col-md-2">{{ getCustomerPlace(slotProps.data.data.CustomerPlacesDropDown) }}</div>
                <div v-if="slotProps.data.data.orderRows" class="col-md-1">{{ totalAmount(slotProps.data.data.orderRows) }}</div>
                <div v-else class="col-md-1"></div>
                <div class="col-md-1">{{ getTrucks(slotProps.data.data.trucks) }}</div>
<!--            <div class="col-md-2"><p>{{ slotProps.data.data.DeliveryPlaceComments }}</p></div>
                <div class="col-md-2"><span v-if="slotProps.data.data.Quantity">{{parseFloat(slotProps.data.data.Quantity).toFixed(2)}}</span></div> -->
              </div>
            </template>
        </DataView>
    </div>
    <div class="row">
      <div class="col-md-12">
         <router-link class="btn btn-primary" :to="{ name: 'OrderCreate', params: {type: 'hydro', schema: ordersSchema}}">
               Skapa ny
          </router-link>
      </div>
    </div>
  </div>
</template>

<script>
import 'primeflex/primeflex.css'
import DataViewPrime from 'primevue/dataview'
import Dropdown from 'primevue/dropdown'
import moment from 'moment'
export default {
  name: 'OrderListByType',
  data () {
    return {
      msg: 'Ordrar',
      customerName: '',
      orders: [],
      customers: [],
      customerPlaces: [],
      ordersSchema: {},
      activeBtn: 'all',
      layout: 'list',
      sortKey: null,
      sortOrder: null,
      sortField: 'id',
      sortOptions: [
        {label: 'Nyast', value: '!createdAt'},
        {label: 'Äldst', value: 'createdAt'},
        {label: 'Ordernummer', value: 'id'}
      ]
    }
  },
  components: {
    'DataView': DataViewPrime,
    'Dropdown': Dropdown,
    'moment': moment
  },
  props: {
    id: '',
    customer: null
  },
  watch: {
    customer: async function (newVal, oldVal) {
      var response = await this.getOrders()
      this.orders = response.orders
      this.customers = response.customers
      this.customerPlaces = response.customerPlaces
      this.ordersSchema = response.schema
      this.filterOrders('all')
    }
  },
  async beforeMount () {
    var response = await this.getOrders()
    this.orders = response.orders
    this.customers = response.customers
    this.customerPlaces = response.customerPlaces
    this.ordersSchema = response.schema
    // this.filterOrders('all')
  },
  computed: {
    activeColumns: function () {
      if (this.ordersSchema.fields) {
        return this.ordersSchema.fields.filter(function (c) {
          return c.showInList
        })
      }
    }
  },
  methods: {
    totalAmount (orderRows) {
      let totalDuration = null
      for (var i = 0; i < orderRows.length; i++) {
        if (orderRows[i].endTime) {
          const pause = orderRows[i].actions.filter(a => a.name === 'Rast').reduce((prev, curr) => {
            return prev.add(moment(curr.endTime).diff(moment(curr.startTime)))
          }, moment.duration(0))
          const duration = moment.duration(moment(orderRows[i].endTime).diff(moment(orderRows[i].startTime))).subtract(pause)
          totalDuration += duration
        }
      }
      let hours = Math.floor(moment.duration(totalDuration).asHours())
      let mins = Math.floor(moment.duration(totalDuration).asMinutes()) - hours * 60
      if (mins.toString().length < 2) {
        mins = '0' + mins
      }
      return hours + ':' + mins + 'h'
    },
    formatDate (theDate) {
      var formattedDate = moment(String(theDate)).format('YYYY-MM-DD')
      return formattedDate
    },
    getCustomer (customerId) {
      var customers = this.customers
      var customer = customers.find(customer => {
        return customer.id === customerId
      })
      return customer.data.name
    },
    getCustomerPlace (customerPlaceId) {
      var customerPlaces = this.customerPlaces
      var customerPlace = customerPlaces.find(customerPlace => {
        return customerPlace.id === customerPlaceId
      })
      return customerPlace.data.name
    },
    getTrucks (trucks) {
      if (trucks && trucks.length > 1) {
        return 'FLERA'
      } else if (trucks.length === 1) {
        return trucks[0].name
      }
    },
    async filterOrders (btnState) {
      this.activeBtn = btnState
      var response = await this.getOrders()
      if (btnState !== 'all') {
        this.orders = response.orders.filter((el) => el.state === btnState)
      } else {
        this.orders = response.orders
      }
    },
    orderDetails (order, ordersSchema) {
      this.$router.push({ name: 'OrderDetails', params: { id: order.id, order: order, schema: ordersSchema } })
    },
    async getOrders () {
      let orderType = this.$route.params.id
      if (orderType === 'standard') {
        orderType = 'hydro'
      }
      let url = '/api/orders/by-type/' + orderType
      if (this.$route.params.customer !== undefined) {
        url = '/api/orders/by-type/' + orderType + '/customer/' + this.$route.params.customer
      }
      let response = await this.$http.get(url)
      if (this.$route.params.customer !== undefined) {
        let customers = response.data.customers.filter((el) => el.id === parseInt(this.$route.params.customer))
        if (customers.length > 0) {
          this.customerName = customers[0].data.name
        }
      }
      return response.data
    },
    onSortChange (event) {
      const value = event.value.value
      const sortValue = event.value
      if (value.indexOf('!') === 0) {
        this.sortOrder = -1
        this.sortField = value.substring(1, value.length)
        this.sortKey = sortValue
      } else {
        this.sortOrder = 1
        this.sortField = value
        this.sortKey = sortValue
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Orders/StandardOrdersList.vue